import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import { IconTemplate } from '@components/Icon/IconTemplate';

export const Wrapper = styled.div`
    padding: ${rem(20)} 0 ${rem(40)} 0;
    border: 1px solid ${({ theme }) => theme.colors.primary};;
    border-radius: ${rem(10)};
    padding: ${rem(20)};
    margin-top: ${rem(50)};
    margin-bottom: ${rem(50)};
    line-height: ${rem(24)};
`;


export const Preview = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
`;

export const ButtonBox = styled.div`
    display: flex;
    justify-content: center;
`;

export const LabelBox = styled.div`
    display: flex;
    justify-content: center;
`;

export const CheckboxLabel = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.h7};
    color: ${({ theme }) => theme.colors.grey};
`;


export const WrapperModal = styled.div`
    padding: ${rem(40)} 0;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.75);
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Modal = styled.div`
    width: 90%;
    height: 90%;;
    background: white;
    border-radius: ${rem(12)};
    position: relative;
    @media (min-width: ${breakpoints.sm}px) {
        width: ${rem(700)};
        height: auto;
    }
`;

export const ModalContent = styled.div`
    width: 100%;
    height: 100%;
   
    @media (max-width: ${breakpoints.sm}px) {
        top:0;
        left:0;
        position: absolute;
        overflow: scroll;
        scrollbar-width: none;
    }
`;


export const CloseButton = styled.div`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    right: ${rem(15)};
    top: ${rem(15)};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    min-height: ${rem(110)};
    align-items: center;
    padding-top: ${rem(50)};
`;


export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${rem(20)} ${rem(20)} ${rem(20)} ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const Icon = styled(IconTemplate)`
    margin-right: ${rem(10)};
    cursor: pointer;

    svg {
        width: ${rem(25)};
        margin-top: ${rem(4)};

        path,
        rect,
      
    }
`;


export const InputSection = styled.div`
    position: relative;
    margin: ${rem(10)} ${rem(10)} ${rem(10)} ${rem(0)};

    
`;

export const InputSectionDate = styled.div`
    position: relative;
    margin: ${rem(10)} ${rem(10)} ${rem(30)} ${rem(0)};

    .rdt {
        min-width: 320px;
      }
    
      .rdt input {
        min-width: 320px;
        height: 42px;
        padding: 0 16px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
      }
    
      .rdt input:focus {
        outline: none;
        border-color: #4f46e5;
      }
`;

export const Input = styled.input<{ marginBottom?: number }>`
    height: ${rem(45)};
    padding: ${rem(5)} ${rem(15)};
    border: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    width: ${rem(320)};
    border-radius: ${rem(4)};
    ${(prop) => (prop.marginBottom ? `margin-bottom: ${rem(prop.marginBottom)} !important` : '')}}

    &.error {
        border-color: ${({ theme }) => theme.colors.danger};
    }
`;

export const Error = styled.span<{ bottom?: number }>`
    color: ${({ theme }) => theme.colors.danger};
    font-size: ${({ theme }) => theme.fontSizes.textSmall};
    position: absolute;
    left: 0;
    bottom: ${(props) => (props.bottom ? `-${rem(props.bottom)}` : `-${rem(24)}`)};
`;

export const Info = styled.div`
    color: ${({ theme }) => theme.colors.info};
    font-size: ${({ theme }) => theme.fontSizes.textSmall};
    line-height: ${rem(16)};
    max-width: ${rem(320)};
    padding-top: ${rem(25)};
`;












export const TabsBorderBottom = styled.div`
    height: ${rem(2)};
    background: ${({ theme }) => theme.colors.secondaryGrey};
    width: 100%;
    position: absolute;
    bottom: 0;
`;

export const Tabs = styled.div`
    display: flex;
    flex-direction: row;
    overflow: scroll;
    scrollbar-width: none;
    padding: ${rem(20)} 0 0 0;
    position: relative;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Tab = styled.div`
    cursor: pointer;
    height: auto;
    color: ${({ theme }) => theme.colors.grey};
    padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
    line-height: ${rem(24)};

    &.selected {
        color: ${({ theme }) => theme.colors.primary};
        border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
    }
`;

export const PlayerWrapper = styled.div`
    border-radius: ${rem(8)};
    margin: ${rem(25)} 0;
    border: 2px solid ${({ theme }) => theme.colors.darkLight};

    &.viewer {
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.75);
        width: 100vw;
        height: 100vh;
        z-index: 999999999;
    }

    iframe {
        border: none;
    }
`;


export const Player = styled.iframe`
    width: 100%;
    min-height: ${rem(500)};
    &.viewer {
        width: 90%;
        height: 90%;
        margin: 2.5% 5%;
    }
`;

export const PlayerCloseButton = styled.button`
    background: none;
    padding: 0;
    border: none;
    cursor: pointer;
    color: white;
    top: ${rem(20)};
    right: ${rem(30)};
    position: fixed;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    z-index: 999999999;
`;

export const OpenViewerButton = styled.button`
    background: ${({ theme }) => theme.colors.black};
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    padding: ${rem(12)};
    border-radius: ${rem(6)};
    margin: 0 auto;
    display: none;

    &:hover {
        opacity: 0.9;
    }

    @media (min-width: ${breakpoints.sm}px) {
        display: block;
    }
`;

export const NoLoggedIn = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    color: ${({ theme }) => theme.colors.black};
    padding: ${rem(60)} ${rem(30)};
    height: ${rem(350)};
    text-align: center;
    border-radius: ${rem(8)};
    margin: ${rem(25)} 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const Zoom = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    color: ${({ theme }) => theme.colors.black};
    padding: ${rem(60)} ${rem(30)};
    border-radius: ${rem(8)};
    margin: ${rem(25)} 0;
    height: ${rem(350)};
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;



export const Message = styled.p`
    margin-bottom: ${rem(40)};
`;
